export default __webpack_public_path__ + "static/media/365-BizTool-Favicon-Dark- Logo.05e3e300.png";